import React from 'react';
import { useCandidateService } from '../services/candidate-service';

const CANDIDATE_NOTFOUND_CPE = 'candidate.notfound.cpe';

export const useCandidateController = () => {
  const {
    professionalSituationService,
    findCandidateByCpf,
    fetchData,
    data,
    loading,
    formQuestionsData,
  } = useCandidateService();
  const [candidateLoading, setCandidateLoading] = React.useState(false);

  const getCandidateByCpf = React.useCallback(
    (cpf) => {
      setCandidateLoading(true);
      return findCandidateByCpf(cpf)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
          if (error.errorCode === CANDIDATE_NOTFOUND_CPE) {
            return { cpf: cpf };
          }
          throw error;
        })
        .finally(() => setCandidateLoading(false));
    },
    [findCandidateByCpf],
  );

  const getProfessionalSituation = React.useCallback(
    (moduleId) => {
      setCandidateLoading(true);
      return professionalSituationService(moduleId)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setCandidateLoading(false));
    },
    [professionalSituationService],
  );

  const getFormQuestions = React.useCallback(
    (moduleId) => {
      setCandidateLoading(true);
      return formQuestionsData(moduleId)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
          throw error;
        })
        .finally(() => setCandidateLoading(false));
    },
    [formQuestionsData],
  );

  return {
    getCandidateByCpf,
    getProfessionalSituation,
    fetchData,
    getFormQuestions,
    data,
    loading,
    candidateLoading,
  };
};
